export const SET_PRIMARY_COLOR_PICKER = 'SET_PRIMARY_COLOR_PICKER'
export const SET_SECONDARY_COLOR_PICKER = 'SET_SECONDARY_COLOR_PICKER'